import { SHIPPING_RATE_LOGS_ACTIONS, initialShippingRateLogsState } from './shippingRateLogs.types'

/**
 * @param {import('./shippingRateLogs.types').ShippingRateLogsSlice} state
 * @param {Object} action
 */
export function shippingRateLogsReducer(state = initialShippingRateLogsState, { type, payload }) {
  switch (type) {
    case SHIPPING_RATE_LOGS_ACTIONS.SET_LOGS:
      return { ...state, data: payload }

    case SHIPPING_RATE_LOGS_ACTIONS.SET_LOG:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case SHIPPING_RATE_LOGS_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case SHIPPING_RATE_LOGS_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case SHIPPING_RATE_LOGS_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    case SHIPPING_RATE_LOGS_ACTIONS.SET_META:
      return {
        ...state,
        pageCount: payload.pageCount,
        rowCount: payload.rowCount,
        currentPage: payload.currentPage,
        perPage: payload.perPage
      }

    default:
      return state
  }
}
